var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32617 20.0059C4.28906 20.0059 3.88477 19.0654 4.44727 18.3271C4.80762 17.8525 5.41406 16.9385 5.76562 16.2793C3.17285 14.9961 1.48535 12.5439 1.48535 9.81934C1.48535 5.48633 5.80957 1.98828 11.1973 1.98828C16.5938 1.98828 20.918 5.48633 20.918 9.81934C20.918 14.293 16.5234 17.7031 10.626 17.624C8.8418 18.8896 6.49512 20.0059 5.32617 20.0059ZM6.37207 18.1865C7.10156 17.8965 8.60449 16.9473 9.59766 16.2002C9.93164 15.9365 10.1953 15.8311 10.5557 15.8311C10.8369 15.8398 11.0566 15.8486 11.1973 15.8486C15.6094 15.8486 19.1162 13.1416 19.1162 9.81934C19.1162 6.49707 15.6094 3.79004 11.1973 3.79004C6.79395 3.79004 3.28711 6.49707 3.28711 9.81934C3.28711 11.9727 4.74609 13.8535 7.25977 15.04C7.78711 15.2861 7.89258 15.6992 7.6377 16.165C7.32129 16.7539 6.69727 17.5713 6.29297 18.0723C6.21387 18.1777 6.25781 18.2305 6.37207 18.1865Z",
    fill: "#0075C9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 4,
    fill: "#F23100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstruction);
export default __webpack_public_path__ + "static/media/icon-instruction.73bc836fc521d9c38bed2128cb6eac8d.svg";
export { ForwardRef as ReactComponent };